import { resolveExtractedStatusDisplay } from 'features/claims/claimsApi'
import { useClaimStatuses, useDetailedClaimStatuses } from 'features/claims/claimsHooks'
import { IClaim } from 'features/claims/types'
import styled from 'styled-components'
import { SlotData } from 'utils/dataExtractor'
import { formatDateOnly } from 'utils/date'
import { formatCurrency } from './ProviderRecord/Internal'

interface IClaimDetailsExtractedProps {
  data: SlotData[]
  claim?: IClaim
}

export const ClaimDetailsExtracted = ({ data, claim }: IClaimDetailsExtractedProps): JSX.Element => {
  const { options: claimStatuses } = useClaimStatuses()
  const { options: detailedClaimStatuses } = useDetailedClaimStatuses()

  const displayValue = (detail: SlotData) => {
    if (detail.typeId === 'decimal') return formatCurrency(detail.value)
    if (detail.typeId === 'dateonly') return detail.value ? formatDateOnly(detail.value) : '---'
    return (
      resolveExtractedStatusDisplay(detail.slot, detail.value, claimStatuses, detailedClaimStatuses, {
        claimStatusCode: claim?.claimStatusCode,
        detailedClaimStatusCode: claim?.detailedClaimStatusCode,
      }) || '---'
    )
  }

  return (
    <>
      <Div>
        <div className="extracted-details">
          {data
            .filter((detail) => detail.value !== '---')
            .map((detail: SlotData) => (
              <div className="extracted-detail" key={detail.entId}>
                <p className="extracted-detail-label">{detail.description}</p>
                <div>
                  <span className="extracted-detail-value">{displayValue(detail)}</span>
                </div>
              </div>
            ))}
        </div>
      </Div>
    </>
  )
}

const Div = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  .claim-details-add {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    gap: 0.5rem;
    margin-bottom: 0px;
    color: ${({ theme }) => theme.colors.grey.neutral};
    ${({ theme }) => theme.typography.s.medium};
    position: absolute;
    bottom: -20px;
    background: #fff;
    padding: 10px 0;
  }

  .extracted-details {
    display: grid;
    grid-template-columns: repeat(7, auto);
    grid-template-rows: repeat(4, auto);
    grid-column-gap: ${({ theme }) => theme.util.pixelToRem(5)};
    row-gap: ${({ theme }) => theme.util.pixelToRem(5)};
    padding: 0.75rem 1.85rem 1.85rem 0;
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    font-style: normal;

    .extracted-detail-label {
      ${({ theme }) => theme.typography.xs.medium};
      color: ${({ theme }) => theme.colors.grey.neutral};
    }
    .extracted-detail-value {
      font-weight: ${({ theme }) => theme.typography.xs.medium};
      ${({ theme }) => theme.typography.s.medium};
      display: inline-flex;
      padding: 0.5rem;
      color: ${({ theme }) => theme.colors.primary.neutral};
      background-color: rgb(249, 249, 251);

      border-radius: 5px;
      .verion {
        display: inline-block;
        svg {
          color: ${({ theme }) => theme.colors.info.darker};
          margin-right: 0.3rem;
          ${({ theme }) => theme.typography.xs.normal};
        }
        .eclipse {
          width: 9ch;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .match {
        color: ${({ theme }) => theme.colors.success.dark};
        ${({ theme }) => theme.typography.s.normal};
        margin-right: ${({ theme }) => theme.util.pixelToRem(5)};
        float: left;
      }
      .nomatch {
        color: ${({ theme }) => theme.colors.warning.darker};
        ${({ theme }) => theme.typography.s.normal};
        margin-right: ${({ theme }) => theme.util.pixelToRem(5)};
        float: left;
      }
      .eclipse {
        width: 9ch;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .call-details-no-extract {
    display: flex;
    width: 100%;
    align-self: center;
    flex-direction: column;
    margin: 100px auto;
    align-items: center;
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    font-style: normal;

    h3 {
      font-weight: ${({ theme }) => theme.fontWeight.bold};
      ${({ theme }) => theme.typography.s.normal};
      float: left;
      line-height: ${({ theme }) => theme.spacing.s};
      text-align: center;
      color: ${({ theme }) => theme.colors.primary.darker};
      margin: ${({ theme }) => theme.util.pixelToRem(5)} 0;
    }
    p {
      font-weight: ${({ theme }) => theme.fontWeight.normal};
      ${({ theme }) => theme.typography.s.normal};
      line-height: 134.4%;
      text-align: center;
      color: ${({ theme }) => theme.colors.grey.neutral};
    }
  }
`
